import React from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";
import renderMarkdown from "../markdown";

const ConfirmationBlock = observer(({ block }) => {
  const resolved = Boolean(block.resolution);
  const destructive = Boolean(block.destructive);

  return (
    <div
      className={`copilotConfirm ${block.title ? "copilotConfirm--card" : ""} ${
        resolved ? "resolved" : ""
      } ${destructive ? "destructive" : ""}`}
    >
      {block.title ? (
        // Same card the CTA plan uses (title / body / facts), so a confirm
        // looks like every other decision card in the thread.
        <div className="copilotCtaCard copilotConfirm__card">
          <div className="copilotCtaCard__title">{block.title}</div>
          {block.body && <div className="copilotCtaCard__body">{block.body}</div>}
          {Array.isArray(block.facts) && block.facts.length > 0 && (
            <dl className="copilotCtaCard__facts">
              {block.facts.map(f => (
                <React.Fragment key={f.label}>
                  <dt className="copilotCtaCard__factLabel">{f.label}</dt>
                  <dd>{f.value}</dd>
                </React.Fragment>
              ))}
            </dl>
          )}
          {/* Who this is about: the same peek rows the table card shows, so a
              "save the top 5" confirm names the people, not just a count. */}
          {block.preview && Array.isArray(block.preview.rows) && block.preview.rows.length > 0 && (
            <div className="copilotTableCard__peek copilotConfirm__preview">
              <div className="copilotTableCard__peekRows">
                <div className="copilotTableCard__peekRow is-head">
                  {block.preview.columns.map(c => (
                    <span className="copilotTableCard__peekCell" key={c.key}>
                      {c.label || c.key}
                    </span>
                  ))}
                </div>
                {block.preview.rows.map((row, i) => (
                  <div className="copilotTableCard__peekRow" key={row.id || i}>
                    {block.preview.columns.map((c, j) => (
                      <span
                        className={`copilotTableCard__peekCell ${j === 0 ? "is-primary" : ""}`}
                        key={c.key}
                        title={row[c.key] || ""}
                      >
                        {row[c.key] || ""}
                      </span>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="copilotConfirm__prompt">
          <i className="material-icons-outlined">
            {destructive ? "error_outline" : "check_circle_outline"}
          </i>
          {/* The prompt carries **bold** — it read as literal asterisks before. */}
          <div className="copilotConfirm__promptBody">
            {renderMarkdown(block.prompt)}
          </div>
        </div>
      )}
      {!resolved ? (
        <div className="copilotConfirm__actions">
          <button
            type="button"
            className={`copilotConfirm__btn primary ${
              destructive ? "danger" : ""
            }`}
            disabled={copilotStore.streaming}
            onClick={() => copilotStore.respondConfirmation(block.id, true)}
          >
            {block.confirmLabel || "Confirm"}
          </button>
          <button
            type="button"
            className="copilotConfirm__btn ghost"
            disabled={copilotStore.streaming}
            onClick={() => copilotStore.respondConfirmation(block.id, false)}
          >
            {block.cancelLabel || "Cancel"}
          </button>
        </div>
      ) : (
        <div className="copilotConfirm__resolution">
          <i className="material-icons-outlined">
            {block.resolution === "confirmed" ? "check_circle" : "cancel"}
          </i>
          <span>
            {block.resolution === "confirmed"
              ? block.confirmLabel || "Confirmed"
              : block.cancelLabel || "Cancelled"}
          </span>
        </div>
      )}
    </div>
  );
});

export default ConfirmationBlock;
